export default "__VITE_ASSET__BZJK633B__"